import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import SingleDatePicker from '../../components/ui/SingleDatePicker';

dayjs.extend(customParseFormat);

interface DatePickerValueProps {
    value: Dayjs | null;
    setValue: (date: Dayjs | null) => void;
    label: string;
    // Historic format: DD.MM.YYYY strings (BookingPage convention).
    availableDates?: string[];
    disabled: boolean;
}

// Visitor-booking date picker. Same UX as `BookingDatePicker`, but exposes
// `setValue` (legacy name) and accepts `availableDates` in DD.MM.YYYY rather
// than YYYY-MM-DD. Both formats are normalised to YYYY-MM-DD before being
// handed to the shared picker.
export default function DatePickerValue(props: DatePickerValueProps) {
    const allowedDays = React.useMemo(
        () =>
            props.availableDates?.map((d) =>
                dayjs(d, 'DD.MM.YYYY').format('YYYY-MM-DD'),
            ),
        [props.availableDates],
    );

    return (
        <SingleDatePicker
            value={props.value}
            onChange={props.setValue}
            label={props.label}
            disabled={props.disabled}
            allowedDays={allowedDays}
        />
    );
}
